import React from "react";
import { dialog, InputJson } from "nq-component";
import { getObjectUseCase, upsertUseCase } from "../../../../usecases/object";
import withRouter from "../../../../withRouter";
import BaseFormPage from "../../../../base/BaseFormPage";
import InputFactory from "../../../../components/InputFactory";
import ScheduleFormPresenter from "./ScheduleFormPresenter";
import SchedulePage from "./shdedule-form/schedule-page/SchedulePage";
import FormFactory from "../../../../components/FormFactory";
import { Spin } from "antd";
import MultipleSelectHierarchy from "../../../../components/common/MultipleSelectHierarchy";

class ScheduleFormPage extends BaseFormPage {
  constructor(props) {
    super(props);
    this.state = {
      object: {},
      advanced: false,
      scheduleArray: [],
      description: "",
      name: "",
      hierarchy: {},
      isAddClick: false,
      deletedObject: [],
      scheduleObject: {},
      isProgress: false,
    };
    this.presenter = new ScheduleFormPresenter(
      this,
      getObjectUseCase(),
      upsertUseCase(),
    );
  }

  async componentDidUpdate(prevProps, prevState) {
    if (prevState.object !== this.state.object) {
      if (this.state.object.id) {
        this.setState({ ...this.state.object });
      }
    }
  }
  getCollectionName() {
    return "schedule_template";
  }

  isAddBtnClick(isAddClick) {
    this.setState({ isAddClick });
  }
  scheduleObject(scheduleObject) {
    this.setState({ scheduleObject });
  }
  scheduleTable(tableData) {
    this.setState({ scheduleArray: tableData });
  }
  // deletedRow(deletedObject) {
  //   this.setState({ deletedObject });
  // }

  handleInputChange(field, value) {
    this.setState({ [field]: value });
  }

  async handleDeleteData(data) {
    this.state.deletedObject.push(data);
    this.setState((prevState) => ({
      scheduleArray: prevState.scheduleArray.filter(
        (item) => item.day !== data.day || item.shift !== data.shift,
      ),
    }));
  }

  handleObjectChange(hierarchy) {
    const entry = Object.fromEntries(
      Object.entries(hierarchy).map(([key, value]) => [
        key.replace(/^selected/, "").replace(/^./, (c) => c.toLowerCase()), // remove 'selected' and lowercase first letter
        value,
      ]),
    );
    this.setState({ hierarchy: entry });
  }

  render() {
    const { object, advanced } = this.state;
    const schema = this.getSchema(this.getCollectionName());
    const label = this.getObjectId() === undefined ? "Add New" : "Update ";
    if (!schema) return <h1>no schema</h1>;
    if (this.state.isProgress) {
      dialog.fire({
        html: (
          <div className="d-flex gap-3 flex-column align-items-center justify-content-center p-5">
            <Spin size="large" />
            <p>Loading...</p>
          </div>
        ),
        footer: false,
      });
    }

    const path = this.props.location.pathname;
    const isViewMode = path.startsWith("/view/");
    // console.log("OBJECT: ", object);
    return (
      <>
        <div className="overflow-auto mt-5">
          <div className="h-100">
            <div className="p-3 p-lg-4">
              <h1 className="fw-bold mt-3 text-capitalize">
                {(schema.label || this.getCollectionName()) + " Details"}
              </h1>
              <div className="mt-3 bg-white shadow rounded p-3 px-lg-5 py-lg-4">
                {/* <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    this.presenter.handleFormSubmit();
                  }}
                > */}
                <div className="row">
                  {advanced ? (
                    <InputJson
                      defaultValue={object}
                      onChange={this.onChangeObject.bind(this)}
                      rows="15"
                    />
                  ) : (
                    <>
                      {["Name", "Description"].map((item) => {
                        return (
                          <div className="p-0 mb-2" key={item}>
                            <label
                              className="fs-sm mb-2"
                              style={{ fontSize: "14px" }}
                            >
                              {item} <span className="text-danger">*</span>
                            </label>
                            <InputFactory
                              type="String"
                              value={this.state[item.toLowerCase()]}
                              disabled={isViewMode}
                              placeholder={item}
                              onChange={(value) =>
                                this.handleInputChange(
                                  item.toLowerCase(),
                                  value,
                                )
                              }
                              required={true}
                            />
                          </div>
                        );
                      })}
                      {/* <div className="row"> */}
                      <div className="p-1">
                        <MultipleSelectHierarchy
                          className="col-lg-6"
                          object={this.state.object}
                          required={false}
                          handleObjectChange={this.handleObjectChange.bind(
                            this,
                          )}
                          disabled={isViewMode}
                        />
                      </div>

                      {/* </div> */}
                      <div className="p-0 mt-2">
                        <FormFactory
                          schema={schema}
                          object={object}
                          disabled={isViewMode}
                          onChange={(value, field) =>
                            this.handleInputChange(field, value)
                          }
                          excludeFields={["id", "name", "description"]}
                          hasLabel={true}
                        />
                      </div>

                      <SchedulePage
                        scheduleName={
                          this.getObjectId() ? object.name : this.state.name
                        }
                        scheduleTable={this.scheduleTable.bind(this)}
                        scheduleArray={this.state.scheduleArray}
                        objectID={this.getObjectId()}
                        isAddBtnClick={this.isAddBtnClick.bind(this)}
                        handleDeleteData={(data) => this.handleDeleteData(data)}
                        scheduleObject={this.scheduleObject.bind(this)}
                        // deletedRow={this.deletedRow.bind(this)}
                        disabled={isViewMode}
                      />
                    </>
                  )}
                </div>
                <div className="mt-4">
                  {!isViewMode && (
                    <button
                      // type="submit"
                      onClick={() => this.presenter.handleFormSubmit()}
                      className="btn btn-primary fs-sm me-3"
                    >
                      <i className="bi bi-file-earmark-check me-2"></i>
                      {label}
                    </button>
                  )}
                  <button
                    type="button"
                    className="btn btn-light fs-sm"
                    onClick={this.onClickBack.bind(this)}
                  >
                    GO BACK
                  </button>
                </div>
                {/* </form> */}
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(ScheduleFormPage);
